import { Col, Row } from 'antd';
import { addNewPhaseToProject, removePhaseFromProject } from 'api';
import React, { useEffect, useState } from 'react';
import { isIPSAdministrator, isIPSDataCreatorOrAdministrator } from 'utils/UserInfo';
import ConfirmDialog from './CommonComponent/DialogBox/ConfirmDialogBox';

function AddOrRemovePhaseSection({
  project,
  setCurrentProject,
  phaseId,
  ipsProjectDetails,
}) {
  const [isLastPhase, setLastPhase] = useState(
    ipsProjectDetails[ipsProjectDetails.length - 1].id.phase === phaseId
  );
  
  useEffect(() => {
    setLastPhase(ipsProjectDetails[ipsProjectDetails.length - 1].id.phase === phaseId)

   },[ipsProjectDetails,phaseId])
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [confirmDialogDetails, setConfirmDialogDetails] = useState({});

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleAddNewPhase = async () => {
    let projectInfo = {
      bpid: project.bpid,
      workOrder: project.workOrder,
      stationName: project.stationName,
    };
    let response = await addNewPhaseToProject(projectInfo);

    if (response?.bpid) {
      setCurrentProject(response);
    }
    setIsModalOpen(false);
  };

  const handleAddNewPhaseDialog = ()=>{
    setConfirmDialogDetails({
      title: `Do you want to Add new phase to ${project.stationName} ?`,
      
      confirmButtonName: 'Yes',
      handleSubmit: handleAddNewPhase,
    });
    setIsModalOpen(true);

  }
  const handelRemovePhase = async (phase) => {
    let projectInfo = {
      bpid: project.bpid,
      workOrder: project.workOrder,
      stationName: project.stationName,
      phase:phase
    };

    let response = await removePhaseFromProject(projectInfo);

    if (response?.bpid) {
      setCurrentProject(response);
    }
    setIsModalOpen(false);
  };

  const handleRemovePhaseDialog = (phase)=>{
    setConfirmDialogDetails({
      title: `Do you want to Remove this Phase from ${project.stationName} ?`,
      submitFunctionArgs:phase,
      confirmButtonName: 'Yes',
      handleSubmit: handelRemovePhase,
    });
    setIsModalOpen(true);

  }
  return (

    <>
      {/* https://jira.aepsc.com/browse/TCHEK-629 */}
      {(isIPSDataCreatorOrAdministrator() &&project.allIPSComplFlag !== 'Y')&& <Row
      
      onClick={e => e.stopPropagation()}
      >
        {isLastPhase && (
          <Col>
            <button
              type='button'
              className='w3-button btn-primary '
              disabled={
                !isIPSDataCreatorOrAdministrator() || project?.allIPSComplFlag === 'Y'
              }
              onClick={handleAddNewPhaseDialog}
            >
              Add New Phase
            </button>
          </Col>
        )}
        {ipsProjectDetails?.length > 1 && (
          <Col>
            <button
              type='button'
              className='w3-button btn-primary '
              disabled={
                !isIPSDataCreatorOrAdministrator() || project?.allIPSComplFlag === 'Y'
              }
              onClick={() => handleRemovePhaseDialog(phaseId)}
            >
              Remove Phase
            </button>
          </Col>
        )}
         <ConfirmDialog
                    show={isModalOpen}
                    title={confirmDialogDetails.title}
                    handleCancel={handleCancel}
                    submitFunctionArgs={confirmDialogDetails.submitFunctionArgs}
                    handleSubmit={confirmDialogDetails.handleSubmit}
          confirmButtonName={confirmDialogDetails.confirmButtonName}
          cancelButtonName={'Cancel'}
                  />
      </Row>}
    </>
  );
}

export default AddOrRemovePhaseSection;
